import styled from "styled-components";


export const SCSalePageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 2rem;
`;

export const SCTopContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 70%;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 80%;
        padding: 0 2rem;
        flex-direction: column;
        align-items: flex-start;
    `}

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
    `}
`;

export const SCLastClaimedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    min-width: 500px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        min-width: unset;
    `}
    .loading {
        width: 100%;
        height: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    > img {
        max-width: 100%;
        box-shadow: ${({ theme }) => theme.boxShadow};
        border-radius: 2rem;
        border: 2px solid ${({ theme }) => theme.yetiBlue};
        &:hover {
            cursor: pointer;
            transform: scale(1.005);
        }
    }
`;

export const SCInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    flex: 1;
    margin-left: 2rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        margin-left: 0;
    `}
    > * {
        margin-bottom: 1rem;
        width: 100%;
    }
`;

export const SCPrices = styled.div`
    display: flex;
    flex-direction: row;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        flex-direction: column;
    `}
    .left {
        width: 240px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        span {
            border: 1px solid ${({ theme }) => theme.newBg1};
            border-radius: 0.5rem;
            margin-bottom: 5px;
            width: 200px;
            padding: 0.5rem;
        }
    }
    .right {
        flex: 1;
        width: calc(100% - 240px);
        > span {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 1.5rem;
            font-weight: 500;
            margin-bottom: 1rem;

        }
    }

`;

export const SCMintSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 3rem;
    justify-content: space-between;
    height: 200px;
    border-radius: 2rem;
    //background-color: ${({ theme }) => theme.newBg3};
    //box-shadow: 0px 0px 10px 0px ${({ theme }) => theme.newBg1};
    padding: 1rem 2rem;
    span {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 1.5rem;
        font-weight: 500;
    }
`;

export const SCCharacterListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 70%;

    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 80%;
        padding: 0 2rem;
        flex-direction: column;
        align-items: flex-start;
    `}

    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
    `}
`;

export const SCCharacterList = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    flex-wrap: wrap;
    border-bottom: 2px solid ${({ theme }) => theme.newBg1};
    margin-bottom: 2rem;
    padding-bottom: 2rem;

    &:last-of-type {
        border-bottom: none;
    }
`;

export const SCCharacterItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 250px;
    padding: 1rem;
    margin: 1rem;
    border-radius: 2rem;
    background-color: ${({ theme }) => theme.newBg3};
    box-shadow: 0px 0px 10px 0px ${({ theme }) => theme.newBg1};

    &.Normal {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    }

    &.Silver {
        box-shadow: 0px 0px 10px 0px silver;
    }

    &.Gold {
        box-shadow: 0px 0px 10px 0px gold;
    }

    > img {
        max-width: 100%;
        margin-bottom: 1rem;
    }
    > span {
        font-size: 1.2rem;
        font-weight: bold;
        margin-bottom: 1rem;
    }
`;